<!-- shared.chats.icon.html !-->
<div class="chatsicon-content-ionic" [ngClass]="{'pending': pendingMessagesRead>0}">{{pendingMessagesRead}}</div>
<div class="chatsicon-content" [ngClass]="{'pending': pendingMessagesRead>0}" routerLink="/chat">
    <div class="icona">
        <i class="fa fa-commenting" aria-hidden="true"></i>
    </div>
    <!-- <div class="numero" [ngClass]="ngclass">{{pendingMessagesRead}}</div>-->
</div>